import cx from "classnames";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";

import { ToastTypes, withToast } from "../../contexts/toastr.context";
import { COMMUNITY_HOMEPAGE_ROUTE } from "../../_pages/community-home/community-home.page";
import { COMMUNITY_BANNER_SETTINGS_PAGE_ROUTE } from "../../_pages/community-settings/community-banner-settings.page";
import { COMMUNITY_SETTING_PAGE_ROUTE } from "../../_pages/community-settings/community-experience-setting.page";
import { COMMUNITY_UPDATE_PAGE_ROUTE } from "../../_pages/community-settings/community-general-settings.page";
import { COMMUNITY_SUBSCRIPTION_PAGE_ROUTE } from "../../_pages/community-settings/community-subscription.page/index";
import { COMMUNITY_THEME_SELECTOR_PAGE_ROUTE } from "../../_pages/community-settings/community-theme-selector.page";
import { COMMUNITY_SETTING_CUSTOM_DOMAIN_PAGE_ROUTE } from "../../_pages/community-settings/custom-subdomain.page";
import { COMMUNITY_SETTING_EMBEDDED_SECTION_PAGE_ROUTE } from "../../_pages/community-settings/embedded-sections.page";
import { getCommunitySettingLeaderboardRelatedPageLink } from "../../_pages/community-settings/leaderboard-related-page";
import { MEMBERSHIPS_PAGE_ROUTE } from "../../_pages/community-settings/membership/membership-page";
import { NOTIFICATION_CENTRE_PAGE_ROUTE } from "../../_pages/community-settings/notification-centre.page";
import { getPaywallPageRoute } from "../../_pages/community-settings/paywall/paywall-settings.page";
import { USER_PROFILE_UPDATE_PAGE_ROUTE } from "../../_pages/community-settings/profile-update.page";
import { USER_API_KEYS_PAGE_ROUTE } from "../../_pages/community-settings/user-apis.page";
import { COMMUNITY_SETTING_WELCOME_MESSAGES_PAGE_ROUTE } from "../../_pages/community-settings/welcome-messages.page";
import { ACCOUNT_VERIFICATION_PAGE_ROUTE } from "../../_pages/settings/contact-verification.page";
import {
  removeActiveGroup,
  setActiveGroup,
  setGroups,
} from "../../_store/_actions/group.actions";
import { setNotifications } from "../../_store/_actions/notification.actions";
import { setPersonalGroup } from "../../_store/_actions/personal-group.actions";
import PremiumChip from "../premium/premium-chip.component";
import UIcon from "../uicon-component";
import { useAppService } from "../../hooks/use-app-service";

const ZAPIER_INTEGRATION_LINK =
  "https://zapier.com/developer/public-invite/144858/e26a0bc7a1e8522ead31720c407fd4ed/";

function CommunitySettingSidebarComponent({
  user,
  community,
  addToast = (e) => {},
  isSidebarOpen = false,
  sidebarIgnoresCommunitySwitcher = false,
  setIsSidebarOpen = (e) => {},
  communityPac,
}) {
  return (
    <div
      onClick={(e) => {
        setIsSidebarOpen(false);
      }}
      className={cx("Sidebar CommunitySettingsSidebar", {
        open: isSidebarOpen,
        "no-switcher": sidebarIgnoresCommunitySwitcher || !user,
      })}>
      <div className="sidebar-content theme-bg-surface rounded  pb-5 ">
        <a href={COMMUNITY_HOMEPAGE_ROUTE}>
          <div className=" px-6 mt-3 mb-2 font-bold flex items-center space-x-4">
            <span className="mt-1">
              <UIcon icon="angle-left" />
            </span>
            <span className="theme-text-default"> Go Back to Community</span>
          </div>
        </a>
        {community && community.myRole === "admin" ? (
          <>
            <div className="SidebarHeader">Setting</div>
            <SidebarLink
              label="General Settings"
              link={COMMUNITY_UPDATE_PAGE_ROUTE}
            />
            <SidebarLink
              label="Community experience "
              link={COMMUNITY_SETTING_PAGE_ROUTE}
              isPremiumAvailable={communityPac?.communityCustomization}
              eventName="community-experience-selected"
            />
            <SidebarLink
              label="Community Banner "
              link={COMMUNITY_BANNER_SETTINGS_PAGE_ROUTE}
              eventName="community-banner-tab-selected"
            />
            <SidebarLink
              label="Onboarding"
              link={COMMUNITY_SETTING_WELCOME_MESSAGES_PAGE_ROUTE}
              eventName="onboarding-tab-selected"
            />
            {community.configuration.isWhiteLabel ? (
              <></>
            ) : (
              <>
                <SidebarLink
                  label="Custom Domain"
                  link={COMMUNITY_SETTING_CUSTOM_DOMAIN_PAGE_ROUTE}
                  isPremiumAvailable={communityPac?.customDomain}
                  eventName="custom-domain-tab-selected"
                />
                <SidebarLink
                  label="Billing"
                  link={COMMUNITY_SUBSCRIPTION_PAGE_ROUTE}
                  eventName="billing-tab-selected"
                />
                <SidebarLink label="Paywall" link={getPaywallPageRoute()} eventName="paywall-tab-selected" />
                <SidebarLink
                  label="Zapier Integration"
                  link={ZAPIER_INTEGRATION_LINK}
                  external
                  isPremiumAvailable={communityPac?.zapierIntegration}
                />
                <SidebarLink
                  label="API Keys"
                  link={USER_API_KEYS_PAGE_ROUTE}
                  isPremiumAvailable={communityPac?.apiKeysAccess}
                />
              </>
            )}
            <SidebarLink
              label="Leaderboard"
              link={getCommunitySettingLeaderboardRelatedPageLink()}
              isPremiumAvailable={communityPac?.leaderboard}
              eventName="leaderboard-tab-selected"
            />
            <SidebarLink
              label="Embedded Channels"
              link={COMMUNITY_SETTING_EMBEDDED_SECTION_PAGE_ROUTE}
              isPremiumAvailable={communityPac?.embedSection}
              eventName="embed-channel-tab-selected-in-settings"
            />
            <SidebarLink
              label="Theme Selector"
              link={COMMUNITY_THEME_SELECTOR_PAGE_ROUTE}
              eventName="theme-tab-selected"
            />
          </>
        ) : (
          <></>
        )}
        {/* <SidebarLink label="Members" link={COMMUNITY_MEMBERS_BULK_ACTION_PAGE_ROUTE} /> */}
        {/* <SidebarLink label="Custom Domain" link={COMMUNITY_CUSTOM_DOMAIN_SETUP_PAGE_ROUTE} /> */}
        {/* <SidebarLink label="Onboarding" link={""} />
                <SidebarLink label="Member Badges" link={""} />
                <SidebarLink label="Single Sign On" link={""} />
                <SidebarLink label="Direct Messaging" link={""} />
                <SidebarLink label="Billing" link={""} /> */}
        <div className="SidebarHeader">Account</div>
        <SidebarLink label="Profile" link={USER_PROFILE_UPDATE_PAGE_ROUTE} eventName="edit-profile-tab-selected" />
        <SidebarLink
          label="Verification"
          link={ACCOUNT_VERIFICATION_PAGE_ROUTE}
        />
        <SidebarLink
          label="Notification Centre"
          link={NOTIFICATION_CENTRE_PAGE_ROUTE}
          eventName="notification-center-tab-selected"
        />
        {community?.myRole === "user" && (
          <SidebarLink label="Membership" link={MEMBERSHIPS_PAGE_ROUTE} />
        )}
      </div>
    </div>
  );
}

/**
 * @param {String} label - The label of the link
 * @param {String} link - route to link to
 * @param {Boolean} external - if true, the link will be opened in a new tab
 * @param {Function} addToast - function to add toast
 * @param {Boolean} isPremiumAvailable - Whether the premium feature is available
 *
 * @returns {JSX.Element}
 *
 */
const SidebarLink = withToast(
  ({
    label = "Link",
    link = "/settings",
    eventName,
    addToast = (e) => {},
    external = false,
    isPremiumAvailable = true,
  }) => {
    const active = window.location.pathname === link;
    const { analyticsService } = useAppService();

    return !external ? (
      <Link
        to={link}
        onClick={(e) => {
          if(eventName)
            analyticsService.track(eventName)
          if (!link) {
            addToast("Coming soon!");
            e.preventDefault();
          }
        }}
        className={cx("SidebarLink flex items-center px-8 my-1", {
          "theme-text-on-primary rounded theme-bg-primary": active,
          "theme-text-heading-2 hover:theme-bg-default": !active,
        })}>
        {label}
        <PremiumChip isAvailable={isPremiumAvailable} className="ml-auto" />
      </Link>
    ) : (
      <a
        href={link}
        onClick={(e) => {
          if (!isPremiumAvailable) {
            addToast(
              "Upgrade to premium plan to enable this feature",
              "",
              ToastTypes.info
            );

            e.preventDefault();
          } else if (!link) {
            addToast("Coming soon!");
            e.preventDefault();
          }
        }}
        target="_blank"
        rel="noopener noreferrer"
        className={cx("SidebarLink flex items-center px-8 my-1", {
          "theme-text-on-primary rounded theme-bg-primary": active,
          "theme-text-heading-2 hover:theme-bg-default": !active,
        })}>
        {label}
        <PremiumChip isAvailable={isPremiumAvailable} className="ml-auto" />
      </a>
    );
  }
);

const mapStateToProps = (state) => ({
  user: state.auth,
  community: state.community,
  groups: state.groups,
  group: state.activeGroup,
  notifications: state.notifications,
  activeTab: state.activeTab,
  activePersonalGroup: state.activePersonalGroup,
  personalGroup: state.personalGroup,
  communityPac: state.communityPac,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateGroups: setGroups,
      setNotifications: setNotifications,
      updateActiveGroup: removeActiveGroup,
      setGroup: setActiveGroup,
      setPersonalGroup: setPersonalGroup,
    },
    dispatch
  );

const CommunitySettingsSidebar = withToast(
  withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(CommunitySettingSidebarComponent)
  )
);

export default CommunitySettingsSidebar;
